<template>
<!--  CARGO_SEARCH_WITHOUT_SHIP-->
  <transition name="fade">
    <div class="wrap" v-show="show" @dragexit="dragTetx" :class="{'modal-with-checklist-section': nameTaskType === 'manual' && activeShip}">
      <select-on-the-map :is-group-country="true" @changeRegion="changeRegion" ref="modalMap"></select-on-the-map>
      <div class="filter"></div>
      <modal-delete-tag ref="modalDeleteTag"></modal-delete-tag>
      <div class="modal"  @dragenter="dragEnter" v-on:mouseenter="dragEnd" v-on:mouseout="dragEnd" @drop="dragEnd">
        <div class="top-block">
          <p v-if="!selectTypeTask" class="fz16 text-dark">{{nameTaskType === 'manual' ? 'Manually task' : nameTaskType === 'vessel' ? 'Vessel search' : nameTaskType === 'cargo' ? 'Cargo search' : ''}}</p>
          <dropdown-manually-task-add v-if="selectTypeTask" ref="dropMan" @cargoOurVessel="cargoOurVesselSearchEvent" @manuallyTask="manuallyTaskEvent" @vesselSearch="vesselSearchEvent" @cargoSearch="cargoSearchEvent" @cargoWithoutVessel="cargoSearchWithoutVesselEvent"></dropdown-manually-task-add>
          <button class="close-menu svg-white-dart" v-on:click="hideModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.51375 7.57923C6.21612 7.28453 6.21612 6.80673 6.51375 6.51204C6.81138 6.21734 7.29392 6.21734 7.59155 6.51204L17.4863 16.298C17.784 16.5927 17.784 17.0705 17.4863 17.3652C17.1887 17.6599 16.7062 17.6599 16.4085 17.3652L6.51375 7.57923Z" fill="#222222"/>
              <path d="M16.4086 6.63595C16.7063 6.34126 17.1888 6.34126 17.4864 6.63596C17.7841 6.93065 17.7841 7.40845 17.4864 7.70314L7.59165 17.4891C7.29402 17.7838 6.81148 17.7838 6.51385 17.4891C6.21622 17.1944 6.21622 16.7166 6.51385 16.4219L16.4086 6.63595Z" fill="#222222"/>
            </svg>
          </button>
        </div>
        <div class="wrap-content">
          <div class="main-content">
            <div class="block-input" v-if="vesselSearch === true || cargoSearch === true || cargoOurVesselSearch === true || cargoWithoutVessel === true">
              <!--            :class="{ 'block-input_error': $v.activeRegion.$error}"-->
              <counterparties-drop
                  :key="show"
                  title="Region"
                  :is-multiple="true"
                  :list = "groupRegionList"
                  :active-item="getActiveGroupRegion(defaultRegionActive)"
                  @select="setActiveRegion"
                  @close="closeRegion"
              ></counterparties-drop>
              <div class="map-block">
                <button class="blue-button-text fz13 fw500" v-on:click="openMapModal">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9205 4.37895C20.1266 4.51848 20.25 4.75114 20.25 5V17C20.25 17.3067 20.0633 17.5825 19.7785 17.6964L14.7785 19.6964C14.5997 19.7679 14.4003 19.7679 14.2215 19.6964L9.5 17.8078L4.77854 19.6964C4.54747 19.7888 4.28561 19.7606 4.07953 19.6211C3.87345 19.4815 3.75 19.2489 3.75 19V7C3.75 6.69333 3.93671 6.41754 4.22146 6.30365L9.22146 4.30365C9.40027 4.23212 9.59973 4.23212 9.77854 4.30365L14.5 6.19223L19.2215 4.30365C19.4525 4.21122 19.7144 4.23943 19.9205 4.37895ZM13.75 7.50778L10.25 6.10778V16.4922L13.75 17.8922V7.50778ZM15.25 17.8922L18.75 16.4922V6.10778L15.25 7.50778V17.8922ZM8.75 16.4922V6.10778L5.25 7.50778V17.8922L8.75 16.4922Z" fill="#094172"/>
                  </svg>
                  Select on the map
                </button>
              </div>
            </div>
            <div class="block-input" v-if="vesselSearch === true">
              <p class="fz12 text-gray">Cargo</p>
              <textarea v-model="cargoName"></textarea>
            </div>
            <div class="assignee-task">
              <p class="fz12 text-gray">Assigned</p>
              <async-select-employees :is-multiple="true" :permission-assigned="(vesselSearch || cargoOurVesselSearch) ? 'ship_task' : ''" v-model="assigneeTask"></async-select-employees>
              <!--            <assignee-task ref="assigneeTask" :permission-assigned="nameTaskType" :key="show" @mountedAssigned="mountedAssigned" @emitGetData="setAssigned"></assignee-task>-->
            </div>
            <div class="block-input" v-if="!cargoOurVesselSearch">
              <async-select
                  :id="'sd2sd2112'"
                  label="Vessel"
                  url="/contract/dropdown"
                  :params="{is_archive: false, contract_type: ['SHIP']}"
                  :allowEmpty="true"
                  :closeOnSelect="true"
                  v-model="activeShip"
                  :placeholder="''"
              />
            </div>
            <div class="block-input">
              <p class="fz12 text-gray">Task name</p>
              <input type="text" class="h36" maxlength="400" :class="{'error-input': errorName}" v-model="taskName">
            </div>
            <div class="block-input">
              <p class="fz12 text-gray">Description of the task</p>
              <!--            <textarea :class="{'error-input': errorDesc}" v-model="descriptionName"></textarea>-->
              <vue-editor v-model="descriptionName" class="edit-block-wrap"></vue-editor>
            </div>
            <div class="block-input" v-if="cargoOurVesselSearch">
              <async-select
                  :id="'sd2sd2112'"
                  label="Vessel"
                  url="/contract/dropdown"
                  :params="{is_archive: false, contract_type: ['SHIP']}"
                  :allowEmpty="true"
                  :closeOnSelect="true"
                  v-model="activeShip"
                  :placeholder="''"
              />
            </div>
            <div class="drag-zone" :class="{'dragMode': dragMode}">
              <svg width="157" height="97" viewBox="0 0 157 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.33496 93L6.43262 90.334H2.67285L1.77051 93H0.177734L3.73926 83.1357H5.39355L8.95508 93H7.33496ZM4.53223 84.7764L3.0625 89.1035H6.04297L4.57324 84.7764H4.53223ZM9.89844 84.1064H11.3818V85.8086H12.749V86.9775H11.3818V90.9424C11.3818 91.2523 11.4525 91.4801 11.5938 91.626C11.735 91.7718 11.9561 91.8447 12.2568 91.8447C12.4756 91.8447 12.6374 91.8333 12.7422 91.8105V92.9795C12.5599 93.0251 12.2865 93.0479 11.9219 93.0479C11.1973 93.0479 10.6777 92.8997 10.3633 92.6035C10.0534 92.3027 9.89844 91.8037 9.89844 91.1064V86.9775H8.85254V85.8086H9.89844V84.1064ZM14.3965 84.1064H15.8799V85.8086H17.2471V86.9775H15.8799V90.9424C15.8799 91.2523 15.9505 91.4801 16.0918 91.626C16.2331 91.7718 16.4541 91.8447 16.7549 91.8447C16.9736 91.8447 17.1354 91.8333 17.2402 91.8105V92.9795C17.0579 93.0251 16.7845 93.0479 16.4199 93.0479C15.6953 93.0479 15.1758 92.8997 14.8613 92.6035C14.5514 92.3027 14.3965 91.8037 14.3965 91.1064V86.9775H13.3506V85.8086H14.3965V84.1064ZM20.8701 91.9541C21.3896 91.9541 21.8249 91.7969 22.1758 91.4824C22.5312 91.1634 22.709 90.7715 22.709 90.3066V89.7393L20.9385 89.8486C20.4964 89.8805 20.1546 89.9899 19.9131 90.1768C19.6761 90.359 19.5576 90.6051 19.5576 90.915C19.5576 91.2295 19.6761 91.4824 19.9131 91.6738C20.1546 91.8607 20.4736 91.9541 20.8701 91.9541ZM20.46 93.123C19.7536 93.123 19.1771 92.9225 18.7305 92.5215C18.2884 92.1204 18.0674 91.5986 18.0674 90.9561C18.0674 90.3271 18.2998 89.8281 18.7646 89.459C19.2295 89.0853 19.888 88.8757 20.7402 88.8301L22.709 88.7139V88.1602C22.709 87.7591 22.5814 87.4469 22.3262 87.2236C22.071 86.9958 21.7178 86.8818 21.2666 86.8818C20.8473 86.8818 20.5055 86.9753 20.2412 87.1621C19.9814 87.349 19.8174 87.6064 19.749 87.9346H18.3545C18.3955 87.2692 18.6826 86.7269 19.2158 86.3076C19.749 85.8883 20.4508 85.6787 21.3213 85.6787C22.1917 85.6787 22.8844 85.8929 23.3994 86.3213C23.9189 86.7497 24.1787 87.3239 24.1787 88.0439V93H22.7637V91.8174H22.7295C22.5244 92.2139 22.2122 92.5306 21.793 92.7676C21.3783 93.0046 20.9339 93.123 20.46 93.123ZM31.7871 88.2832H30.3789C30.3014 87.8776 30.1146 87.5472 29.8184 87.292C29.5267 87.0368 29.1507 86.9092 28.6904 86.9092C28.1162 86.9092 27.6559 87.1348 27.3096 87.5859C26.9678 88.0326 26.7969 88.6387 26.7969 89.4043C26.7969 90.1836 26.9678 90.7943 27.3096 91.2363C27.6559 91.6784 28.1208 91.8994 28.7041 91.8994C29.1553 91.8994 29.5244 91.7832 29.8115 91.5508C30.1032 91.3138 30.2923 90.9857 30.3789 90.5664H31.8008C31.7233 91.3366 31.3997 91.9587 30.8301 92.4326C30.265 92.902 29.5518 93.1367 28.6904 93.1367C27.6559 93.1367 26.8311 92.804 26.2158 92.1387C25.6006 91.4688 25.293 90.5573 25.293 89.4043C25.293 88.265 25.6006 87.3604 26.2158 86.6904C26.8311 86.016 27.6514 85.6787 28.6768 85.6787C29.57 85.6787 30.2946 85.9294 30.8506 86.4307C31.4066 86.9274 31.7188 87.5449 31.7871 88.2832ZM32.9014 93V83.1357H34.3643V87.0117H34.3984C34.599 86.5879 34.8929 86.262 35.2803 86.0342C35.6676 85.8018 36.1325 85.6855 36.6748 85.6855C37.4587 85.6855 38.0739 85.9271 38.5205 86.4102C38.9717 86.8932 39.1973 87.5449 39.1973 88.3652V93H37.7139V88.6523C37.7139 88.1146 37.5794 87.6976 37.3105 87.4014C37.0462 87.1051 36.6566 86.957 36.1416 86.957C35.5993 86.957 35.1686 87.1302 34.8496 87.4766C34.5352 87.8184 34.3779 88.2741 34.3779 88.8438V93H32.9014ZM43.9004 93V86.9775H42.9092V85.8223H43.9004V85.1182C43.9004 84.4163 44.0713 83.8991 44.4131 83.5664C44.7549 83.2337 45.2904 83.0674 46.0195 83.0674C46.3158 83.0674 46.5915 83.0902 46.8467 83.1357V84.2295C46.7008 84.2021 46.5208 84.1885 46.3066 84.1885C45.6777 84.1885 45.3633 84.5075 45.3633 85.1455V85.8223H46.8193V86.9775H45.3838V93H43.9004ZM48.0293 93V85.8086H49.5059V93H48.0293ZM49.376 84.5098C49.2074 84.6738 49.0046 84.7559 48.7676 84.7559C48.5306 84.7559 48.3278 84.6738 48.1592 84.5098C47.9951 84.3457 47.9131 84.1475 47.9131 83.915C47.9131 83.6781 47.9951 83.4775 48.1592 83.3135C48.3278 83.1494 48.5306 83.0674 48.7676 83.0674C49.0091 83.0674 49.2119 83.1494 49.376 83.3135C49.5446 83.4775 49.6289 83.6781 49.6289 83.915C49.6289 84.1475 49.5446 84.3457 49.376 84.5098ZM51.0713 93V83.1357H52.5479V93H51.0713ZM58.3242 87.3877C58.0007 87.0413 57.5837 86.8682 57.0732 86.8682C56.5628 86.8682 56.139 87.0436 55.8018 87.3945C55.4645 87.7409 55.2777 88.1898 55.2412 88.7412H58.8369C58.8187 88.1852 58.6478 87.734 58.3242 87.3877ZM58.8301 90.8877H60.2314C60.1266 91.5485 59.7894 92.0885 59.2197 92.5078C58.6501 92.9271 57.9551 93.1367 57.1348 93.1367C56.082 93.1367 55.2526 92.8063 54.6465 92.1455C54.0449 91.4801 53.7441 90.5778 53.7441 89.4385C53.7441 88.3083 54.0449 87.3991 54.6465 86.7109C55.2526 86.0228 56.0615 85.6787 57.0732 85.6787C58.0667 85.6787 58.8551 86.0046 59.4385 86.6562C60.0218 87.3034 60.3135 88.1738 60.3135 89.2676V89.7734H55.2344V89.8623C55.2344 90.4912 55.4098 90.9948 55.7607 91.373C56.1117 91.7513 56.5811 91.9404 57.1689 91.9404C57.5837 91.9404 57.9391 91.8447 58.2354 91.6533C58.5316 91.4619 58.7298 91.2067 58.8301 90.8877ZM64.7363 84.1064H66.2197V85.8086H67.5869V86.9775H66.2197V90.9424C66.2197 91.2523 66.2904 91.4801 66.4316 91.626C66.5729 91.7718 66.7939 91.8447 67.0947 91.8447C67.3135 91.8447 67.4753 91.8333 67.5801 91.8105V92.9795C67.3978 93.0251 67.1243 93.0479 66.7598 93.0479C66.0352 93.0479 65.5156 92.8997 65.2012 92.6035C64.8913 92.3027 64.7363 91.8037 64.7363 91.1064V86.9775H63.6904V85.8086H64.7363V84.1064ZM74.1973 92.1387C73.5775 92.804 72.7503 93.1367 71.7158 93.1367C70.6813 93.1367 69.8542 92.804 69.2344 92.1387C68.6146 91.4688 68.3047 90.5573 68.3047 89.4043C68.3047 88.2559 68.6146 87.349 69.2344 86.6836C69.8542 86.0137 70.6813 85.6787 71.7158 85.6787C72.7503 85.6787 73.5775 86.0137 74.1973 86.6836C74.8171 87.349 75.127 88.2559 75.127 89.4043C75.127 90.5573 74.8171 91.4688 74.1973 92.1387ZM71.7158 91.9199C72.3037 91.9199 72.7686 91.6989 73.1104 91.2568C73.4521 90.8148 73.623 90.1973 73.623 89.4043C73.623 88.6159 73.4499 88.0007 73.1035 87.5586C72.7617 87.1165 72.2992 86.8955 71.7158 86.8955C71.1325 86.8955 70.6676 87.1165 70.3213 87.5586C69.9795 88.0007 69.8086 88.6159 69.8086 89.4043C69.8086 90.1973 69.9795 90.8148 70.3213 91.2568C70.6676 91.6989 71.1325 91.9199 71.7158 91.9199ZM79.543 84.1064H81.0264V85.8086H82.3936V86.9775H81.0264V90.9424C81.0264 91.2523 81.097 91.4801 81.2383 91.626C81.3796 91.7718 81.6006 91.8447 81.9014 91.8447C82.1201 91.8447 82.2819 91.8333 82.3867 91.8105V92.9795C82.2044 93.0251 81.931 93.0479 81.5664 93.0479C80.8418 93.0479 80.3223 92.8997 80.0078 92.6035C79.6979 92.3027 79.543 91.8037 79.543 91.1064V86.9775H78.4971V85.8086H79.543V84.1064ZM83.665 93V83.1357H85.1279V87.0117H85.1621C85.3626 86.5879 85.6566 86.262 86.0439 86.0342C86.4313 85.8018 86.8962 85.6855 87.4385 85.6855C88.2223 85.6855 88.8376 85.9271 89.2842 86.4102C89.7354 86.8932 89.9609 87.5449 89.9609 88.3652V93H88.4775V88.6523C88.4775 88.1146 88.3431 87.6976 88.0742 87.4014C87.8099 87.1051 87.4202 86.957 86.9053 86.957C86.363 86.957 85.9323 87.1302 85.6133 87.4766C85.2988 87.8184 85.1416 88.2741 85.1416 88.8438V93H83.665ZM91.4375 93V85.8086H92.9141V93H91.4375ZM92.7842 84.5098C92.6156 84.6738 92.4128 84.7559 92.1758 84.7559C91.9388 84.7559 91.736 84.6738 91.5674 84.5098C91.4033 84.3457 91.3213 84.1475 91.3213 83.915C91.3213 83.6781 91.4033 83.4775 91.5674 83.3135C91.736 83.1494 91.9388 83.0674 92.1758 83.0674C92.4173 83.0674 92.6201 83.1494 92.7842 83.3135C92.9528 83.4775 93.0371 83.6781 93.0371 83.915C93.0371 84.1475 92.9528 84.3457 92.7842 84.5098ZM94.2949 87.8457C94.2949 87.2031 94.5547 86.6813 95.0742 86.2803C95.5938 85.8792 96.2728 85.6787 97.1113 85.6787C97.9089 85.6787 98.5628 85.8815 99.0732 86.2871C99.5882 86.6882 99.8571 87.21 99.8799 87.8525H98.4922C98.4557 87.5244 98.3122 87.2669 98.0615 87.0801C97.8109 86.8932 97.4805 86.7998 97.0703 86.7998C96.6693 86.7998 96.3457 86.8887 96.0996 87.0664C95.8581 87.2441 95.7373 87.4743 95.7373 87.7568C95.7373 88.1943 96.1042 88.5042 96.8379 88.6865L98.0479 88.9668C98.7725 89.14 99.2852 89.377 99.5859 89.6777C99.8913 89.974 100.044 90.3887 100.044 90.9219C100.044 91.5781 99.766 92.1113 99.21 92.5215C98.6585 92.9316 97.9408 93.1367 97.0566 93.1367C96.2135 93.1367 95.5254 92.9362 94.9922 92.5352C94.4635 92.1341 94.1696 91.6009 94.1104 90.9355H95.5732C95.6325 91.2819 95.7943 91.5485 96.0586 91.7354C96.3229 91.9176 96.6784 92.0088 97.125 92.0088C97.5671 92.0088 97.9157 91.9245 98.1709 91.7559C98.4307 91.5827 98.5605 91.3503 98.5605 91.0586C98.5605 90.8262 98.4831 90.6416 98.3281 90.5049C98.1732 90.3682 97.9089 90.252 97.5352 90.1562L96.25 89.8418C94.9466 89.5273 94.2949 88.862 94.2949 87.8457ZM107.782 85.6924C108.698 85.6924 109.432 86.0273 109.983 86.6973C110.535 87.3672 110.811 88.2695 110.811 89.4043C110.811 90.5391 110.537 91.4437 109.99 92.1182C109.443 92.7881 108.716 93.123 107.81 93.123C107.299 93.123 106.846 93.0068 106.449 92.7744C106.057 92.542 105.757 92.223 105.547 91.8174H105.513V95.3789H104.036V85.8086H105.465V87.0459H105.492C105.706 86.6266 106.014 86.2962 106.415 86.0547C106.816 85.8132 107.272 85.6924 107.782 85.6924ZM107.393 91.8721C107.976 91.8721 108.438 91.651 108.78 91.209C109.122 90.7624 109.293 90.1608 109.293 89.4043C109.293 88.6523 109.122 88.0531 108.78 87.6064C108.438 87.1598 107.976 86.9365 107.393 86.9365C106.827 86.9365 106.372 87.1621 106.025 87.6133C105.679 88.0645 105.506 88.6615 105.506 89.4043C105.506 90.1517 105.677 90.751 106.019 91.2021C106.365 91.6488 106.823 91.8721 107.393 91.8721ZM114.468 91.9541C114.987 91.9541 115.423 91.7969 115.773 91.4824C116.129 91.1634 116.307 90.7715 116.307 90.3066V89.7393L114.536 89.8486C114.094 89.8805 113.752 89.9899 113.511 90.1768C113.274 90.359 113.155 90.6051 113.155 90.915C113.155 91.2295 113.274 91.4824 113.511 91.6738C113.752 91.8607 114.071 91.9541 114.468 91.9541ZM114.058 93.123C113.351 93.123 112.775 92.9225 112.328 92.5215C111.886 92.1204 111.665 91.5986 111.665 90.9561C111.665 90.3271 111.897 89.8281 112.362 89.459C112.827 89.0853 113.486 88.8757 114.338 88.8301L116.307 88.7139V88.1602C116.307 87.7591 116.179 87.4469 115.924 87.2236C115.669 86.9958 115.315 86.8818 114.864 86.8818C114.445 86.8818 114.103 86.9753 113.839 87.1621C113.579 87.349 113.415 87.6064 113.347 87.9346H111.952C111.993 87.2692 112.28 86.7269 112.813 86.3076C113.347 85.8883 114.049 85.6787 114.919 85.6787C115.789 85.6787 116.482 85.8929 116.997 86.3213C117.517 86.7497 117.776 87.3239 117.776 88.0439V93H116.361V91.8174H116.327C116.122 92.2139 115.81 92.5306 115.391 92.7676C114.976 93.0046 114.532 93.123 114.058 93.123ZM119.923 95.6797C119.645 95.6797 119.444 95.6683 119.321 95.6455V94.4492C119.394 94.4674 119.554 94.4766 119.8 94.4766C120.146 94.4766 120.417 94.3968 120.613 94.2373C120.809 94.0824 120.964 93.8203 121.078 93.4512C121.078 93.4466 121.101 93.3714 121.146 93.2256L121.208 93.0068L118.61 85.8086H120.21L122.035 91.6602H122.056L123.881 85.8086H125.439L122.739 93.376C122.434 94.2464 122.076 94.848 121.666 95.1807C121.256 95.5133 120.675 95.6797 119.923 95.6797ZM126.308 93V85.8086H127.716V87.0186H127.75C127.914 86.613 128.176 86.2894 128.536 86.0479C128.896 85.8063 129.315 85.6855 129.794 85.6855C130.291 85.6855 130.712 85.8086 131.059 86.0547C131.41 86.3008 131.658 86.6471 131.804 87.0938H131.838C132.025 86.6562 132.316 86.3122 132.713 86.0615C133.114 85.8109 133.57 85.6855 134.08 85.6855C134.791 85.6855 135.361 85.902 135.789 86.335C136.217 86.7679 136.432 87.3421 136.432 88.0576V93H134.948V88.4131C134.948 87.9482 134.827 87.5882 134.586 87.333C134.349 87.0778 134.012 86.9502 133.574 86.9502C133.137 86.9502 132.779 87.096 132.501 87.3877C132.228 87.6794 132.091 88.0531 132.091 88.5088V93H130.642V88.3037C130.642 87.889 130.519 87.5609 130.272 87.3193C130.026 87.0732 129.696 86.9502 129.281 86.9502C128.844 86.9502 128.484 87.1029 128.201 87.4082C127.923 87.709 127.784 88.0918 127.784 88.5566V93H126.308ZM142.119 87.3877C141.796 87.0413 141.379 86.8682 140.868 86.8682C140.358 86.8682 139.934 87.0436 139.597 87.3945C139.259 87.7409 139.073 88.1898 139.036 88.7412H142.632C142.614 88.1852 142.443 87.734 142.119 87.3877ZM142.625 90.8877H144.026C143.922 91.5485 143.584 92.0885 143.015 92.5078C142.445 92.9271 141.75 93.1367 140.93 93.1367C139.877 93.1367 139.048 92.8063 138.441 92.1455C137.84 91.4801 137.539 90.5778 137.539 89.4385C137.539 88.3083 137.84 87.3991 138.441 86.7109C139.048 86.0228 139.856 85.6787 140.868 85.6787C141.862 85.6787 142.65 86.0046 143.233 86.6562C143.817 87.3034 144.108 88.1738 144.108 89.2676V89.7734H139.029V89.8623C139.029 90.4912 139.205 90.9948 139.556 91.373C139.907 91.7513 140.376 91.9404 140.964 91.9404C141.379 91.9404 141.734 91.8447 142.03 91.6533C142.326 91.4619 142.525 91.2067 142.625 90.8877ZM145.257 93V85.8086H146.665V87.0117H146.699C146.9 86.5924 147.191 86.2666 147.574 86.0342C147.957 85.8018 148.42 85.6855 148.962 85.6855C149.75 85.6855 150.363 85.9225 150.801 86.3965C151.238 86.8659 151.457 87.5153 151.457 88.3447V93H149.974V88.6318C149.974 88.085 149.844 87.6702 149.584 87.3877C149.329 87.1006 148.948 86.957 148.442 86.957C147.923 86.957 147.508 87.1257 147.198 87.4629C146.888 87.8001 146.733 88.249 146.733 88.8096V93H145.257ZM153.316 84.1064H154.8V85.8086H156.167V86.9775H154.8V90.9424C154.8 91.2523 154.87 91.4801 155.012 91.626C155.153 91.7718 155.374 91.8447 155.675 91.8447C155.894 91.8447 156.055 91.8333 156.16 91.8105V92.9795C155.978 93.0251 155.704 93.0479 155.34 93.0479C154.615 93.0479 154.096 92.8997 153.781 92.6035C153.471 92.3027 153.316 91.8037 153.316 91.1064V86.9775H152.271V85.8086H153.316V84.1064Z" fill="#094172"/>
                <path d="M88.6785 46.9363C88.8935 47.1514 89.1744 47.2565 89.4548 47.2565C89.7357 47.2565 90.0165 47.1492 90.2312 46.9363C90.6591 46.5084 90.6591 45.8133 90.2312 45.3854L78.7795 33.9358C78.778 33.9344 78.7765 33.9329 78.7751 33.9314L78.7115 33.8678C78.319 33.4754 77.6827 33.4754 77.2903 33.8678L77.2289 33.9292C77.2274 33.9307 77.2259 33.9321 77.2245 33.9336L65.7701 45.3857C65.3422 45.8136 65.3422 46.5088 65.7701 46.9367C66.198 47.3646 66.8932 47.3646 67.3211 46.9367L76.9043 37.3557V56.6758C76.9043 57.2812 77.3958 57.7723 78.0009 57.7723C78.6063 57.7723 79.0974 57.2808 79.0974 56.6758V37.3553L88.6785 46.9363Z" fill="#094172"/>
                <path d="M99.53 26.8769C96.8299 19.281 89.7012 14.2227 81.5829 14.2227C73.9322 14.2227 67.0509 18.8244 64.0744 25.7998C62.6727 25.1506 61.1482 24.8127 59.5999 24.8127C53.6994 24.8127 48.8958 29.6078 48.8848 35.5058C45.8164 37.853 44 41.4985 44 45.3768C44 52.2118 49.5759 57.7722 56.6127 57.7744C56.6917 57.7744 56.7707 57.7766 56.841 57.7766C56.9156 57.7766 56.9814 57.7766 57.034 57.7722H68.5934C69.1989 57.7722 69.69 57.2807 69.69 56.6756C69.69 56.0706 69.1985 55.5791 68.5934 55.5791H56.9766C56.8693 55.5857 56.7571 55.5813 56.6498 55.5791L56.4259 55.5769C50.7842 55.5769 46.1935 51.0012 46.1935 45.375C46.1935 42.0124 47.8518 38.8602 50.6287 36.9475L51.1331 36.4454L51.0783 35.5286C51.0783 30.8301 54.9015 27.007 59.5999 27.007C61.1747 27.007 62.7212 27.45 64.0722 28.2859L65.2324 29.0053L65.6842 27.7154C68.0486 20.9573 74.4362 16.4191 81.5847 16.4191C88.9638 16.4191 95.4212 21.1418 97.6518 28.1738L97.8559 28.8164L98.5227 28.9237C105.059 29.981 109.806 35.5525 109.806 42.1724C109.806 49.5665 103.776 55.5809 96.3667 55.5809H87.4062C86.8008 55.5809 86.3096 56.0724 86.3096 56.6775C86.3096 57.2826 86.8011 57.7741 87.4062 57.7741H96.3667C104.987 57.7741 112 50.7748 112 42.172C111.998 34.6922 106.793 28.3642 99.53 26.8769Z" fill="#094172"/>
              </svg>
              <input type="file" multiple v-on:change="testFile">
            </div>
            <div class="block-two-inputs">
              <div>
                <p class="fz12 text-gray">Priority</p>
                <select-priority :key="show" ref="priority" @mountedPriority="mountedPriority" @emitGetPriotity="setPriority"></select-priority>
              </div>

              <div>
                <p class="fz12 text-gray">Tag</p>
                <tag-select  @deleteUsageTag="deleteTagWhichUsed" :key="show" ref="tagsSel" @mountedTagSelect="mountedTagSelect" @emitGetTags="setTags"></tag-select>
              </div>
            </div>
            <div class="file-block" v-if="getPermissionsForUserCanAddFile">
              <vue-dropzone :options="dropzoneOptions" :useCustomSlot=true ref="dropzone" id="dropzone">
                <div class="dropzone-custom-content">
                  <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                  <div class="subtitle">...or click to select a file from your computer</div>
                </div>
              </vue-dropzone>
              <!--            <input type="file" multiple @change="testFile">-->
            </div>

            <div :class="{'displayNone': !buttonShowAll && nameTaskType !== 'manual'}">
<!--              <div class="block-input">-->
<!--                <counterparties-drop-->
<!--                    title="Checklists"-->
<!--                    :list="getCheckList"-->
<!--                    :is-multiple="true"-->
<!--                    :active-item="defaultActiveCheckList"-->
<!--                    @select="setActiveChecklist"-->
<!--                ></counterparties-drop>-->
<!--              </div>-->
<!--              <div class="wrap-button-for-block">-->
<!--                <button class="blue-button-text fz13 fw500" v-on:click="openChekcListModal">-->
<!--                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path d="M18.1088 5.89833C17.5331 5.31995 16.7695 5 15.9528 5C15.1403 5 14.3726 5.31995 13.7969 5.89833L5.74055 13.9915C5.65071 14.0817 5.59763 14.1966 5.57721 14.3197L5.00555 18.3437C4.98105 18.5201 5.03822 18.7006 5.1648 18.8277C5.27097 18.9385 5.42205 19 5.57313 19C5.59763 19 5.61805 19 5.64255 18.9959L9.71358 18.4873C9.84017 18.4708 9.95858 18.4134 10.0484 18.3232L18.1088 10.2259C19.2971 9.02813 19.2971 7.092 18.1088 5.89833ZM9.37875 17.3674L6.24279 17.7571L6.68379 14.6683L13.5764 7.74421L16.2673 10.4474L9.37875 17.3674ZM17.3044 9.41781L17.0798 9.64342L14.3889 6.94023L14.6135 6.71462C14.9688 6.34544 15.4465 6.14855 15.9569 6.14855C16.4633 6.14855 16.9451 6.34544 17.3044 6.71052C17.6637 7.07559 17.8638 7.55142 17.8638 8.06417C17.8638 8.57281 17.6678 9.05684 17.3044 9.41781Z" fill="#094172"/>-->
<!--                  </svg>-->
<!--                  Edit checklist-->
<!--                </button>-->
<!--              </div>-->
              <!--          <div class="block-two-inputs">-->
              <!--            <div>-->
              <!--              <select-due-date></select-due-date>-->
              <!--            </div>-->
              <!--            <div></div>-->
              <!--          </div>-->
              <div class="block-input mt8" v-if="vesselSearch === true">
                <!--              <counterparties-drop-->
                <!--                  :key="show"-->
                <!--                  title="Charterer"-->
                <!--                  :list = "getClientsFormAddModal"-->
                <!--                  :active-item="defaultClientActive"-->
                <!--                  @select="setActiveClient"-->
                <!--              ></counterparties-drop>-->
                <async-select
                    id="coun2333terparty"
                    label="Charterer"
                    url="/client/dropdown"
                    :params="{is_archived: false, ordering: 'company_name'}"
                    watchKey="company_name"
                    :allowEmpty="true"
                    :closeOnSelect="true"
                    v-model="activeClient"
                    placeholder=""
                />
              </div>
              <div class="block-input" v-if="vesselSearch === true || cargoSearch === true || cargoOurVesselSearch === true || cargoWithoutVessel === true">
                <!--              <counterparties-drop-->
                <!--                  :key="show"-->
                <!--                  title="Broker"-->
                <!--                  :list = "getClientsFormAddModal"-->
                <!--                  :active-item="defaultBrokerActive"-->
                <!--                  @select="setActiveBroker"-->
                <!--              ></counterparties-drop>-->
<!--                <p class="">Checklist</p>-->
                <async-select
                    class="drop block-from-inputs"
                    id="counterpart32y"
                    label="Broker"
                    url="/client/dropdown"
                    :placeholder="''"
                    :params="{is_archived: false, ordering: 'company_name', has_broker: true}"
                    watchKey="company_name"
                    :allowEmpty="true"
                    :closeOnSelect="true"
                    v-model="activeBroker"
                />
              </div>
              <!--            <button v-on:click="clearData">Clear</button>-->
              <!--            {{date}}-->
              <!--            <br>-->
              <!--            {{activeDaysForRepeat}}-->
              <!--            <br>-->
              <!--            {{due_date_status}}-->
              <!--            <br>-->
              <!--            {{formSelectDate}}-->
              <!--            <div class="block-two-inputs">-->
              <!--              <div>-->
              <!--                <p class="fz12 text-gray">Due Date</p>-->
              <!--                <div class="date-pick">-->
              <!--                  <select-due-date-->
              <!--                      ref="selectDueaDate"-->
              <!--                      @change="setDueDate"-->
              <!--                      :activeDueDate="date"-->
              <!--                      :activeCustomDays="activeDaysForRepeat"-->
              <!--                      :due_date_status="due_date_status"-->
              <!--                  ></select-due-date>-->
              <!--                </div>-->
              <!--              </div>-->
              <!--              <div>-->
              <!--                <p class="fz12 text-gray">Due Time</p>-->
              <!--                <time-select :key="show" ref="timeSelect" @mountedTime="mountedTime" @emitGetDate="time2Set"></time-select>-->
              <!--              </div>-->
              <!--            </div>-->
              <div class="block-input due-date-block">
                <p class="fz12 text-gray">Due Date</p>
                <div class="date-pick">
                  <select-due-date
                      ref="selectDueaDate"
                      @change="setDueDate"
                      :activeDueDate="date"
                      :activeCustomDays="activeDaysForRepeat"
                      :due_date_status="due_date_status"
                  ></select-due-date>
                </div>
              </div>
            </div>
            <div class="block-input" v-if="nameTaskType !== 'manual'">
              <button class="button-blue-border" v-on:click="buttonShowAll = !buttonShowAll">
                <span>{{buttonShowAll ? 'Hide' : 'Show'}}</span>
                <svg :class="{'r180' : buttonShowAll}" data-v-71db1315="" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-71db1315="" d="M2 4.3999L6.00001 8.3999L10 4.3999H2Z" fill="#2C2C2C"></path></svg>
              </button>
            </div>
          </div>
          <div class="checkbox-section" v-if="nameTaskType === 'manual' && activeShip">
            <checklist-in-task-modal @changeCheckList="(e)=> {actualListCheckList = e}" @changeSelectedIds="(e)=> {actualSelectedIdsChecklist = e}" :selectedVessel="getSelectedVessel()"></checklist-in-task-modal>
          </div>
        </div>
        <div class="bottom-panel">
          <button class="fz14 blue-button-text" v-on:click="hideModal">Cancel</button>
          <button class="fz14 fw500 blue-button h32" v-on:click="createTask">Create Task</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { validationMixin } from 'vuelidate'
import moment from 'moment';
import DropdownManuallyTaskAdd from "@/components/tasks/manually-task-add/dropdown-manually-task-add";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'vue2-datepicker/index.css';
import SelectPriority from "@/components/tasks/manually-task-add/selectPriority";
import TagSelect from "@/components/tasks/manually-task-add/tagSelect";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import ModalDeleteTag from "@/components/tasks/modalDeleteTag";
import CounterpartiesDrop from "@/components/counterparties/counterpartiesAdd/counterpartiesDrop";
import SelectOnTheMap from "@/components/tasks/manually-task-add/selectOnTheMap/selectOnTheMap";
import {required} from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import SelectDueDate from "@/components/tasks/selectDueDate/selectDueDate";
import AsyncSelect from "@/components/reuse/asyncSelect";
import AsyncSelectEmployees from "@/components/tasks/async-select-employees";
import ChecklistInTaskModal from "@/components/checklist/checklist-in-task-modal";

export default {
  name: "manually-task-add",
  mixins: [validationMixin],
  computed: {
    ...mapGetters(["getEmployeesDataAll", "getCheckList", "getCheckListForSelect", "getContracts", "getLoginData", "getPermissionsForUserCreateManualTask","getPermissionsForUserCanAddFile","getResponseCreateTask"]),
    ...mapState({
      clients: state => state.counterparties.clientsDrop,
    }),
    getClientsFormAddModal() {
      let clients = [];
      clients = this.clients.map(a=> {
        return {id: a.id, name: a.company_name}
      })
      return clients
    },
  },

  components: {
    ChecklistInTaskModal,
    AsyncSelectEmployees,
    AsyncSelect,
    SelectDueDate,
    VueEditor,
    SelectOnTheMap,
    CounterpartiesDrop,
    ModalDeleteTag,
    TagSelect,
    SelectPriority, DropdownManuallyTaskAdd, vueDropzone: vue2Dropzone},
  data() {
    return {
      actualListCheckList: [],
      actualSelectedIdsChecklist: [],
      buttonShowAll: false,
      groupRegionList: [
        {name: 'Singapore – Japan (incl. Aussie)', listRegion: ['STH PACIFIC 1', 'FEAST', 'SE ASIA', 'W AUSSIE', 'E AUSSIE', 'NWST PASSAGE', 'NZ']},
        {name: 'Persian gulf – Singapore (incl. east and south africa)', listRegion: ['SW AFRICA', 'NW AFRICA', 'AG', 'E AFRICA', 'EC INDIA', 'INDIAN OCEAN', 'RED SEA', 'STH AFRICA', 'STH INDIAN OCEAN', 'WC INDIA']},
        {name: 'Mediterranean - Black sea range (incl red sea)', listRegion: ['BLACK SEA', 'CASPIAN', 'E MED', 'W MED']},
        {name: 'Gibraltar – Baltic (incl west africa)', listRegion: ['Spain Atl', 'ARAG', 'BALTIC', 'French Atl', 'N CONT', 'UK EIRE']},
        {name: 'USG – USEC', listRegion: ['CARIBS', 'CENTRAL ATLANTIC', 'EC CAN', 'ECCA', 'GREAT LAKES', 'MIDNORTH ATLANTIC', 'ST LAWRENCE', 'USEC', 'ASG']},
        {name: 'NCSA – ECSA', listRegion: ['ECSA', 'NCSA', 'STH ANTARCTICA', 'WCCA', 'WCSA']},
        {name: 'NOPAC – WCSA', listRegion: ['STH PACIFIC 2', 'MID PACIFIC', 'NEST PASSAGE', 'NOPAC']},
      ],
      show: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      cargoName: "",
      date: null,
      open: false,
      taskName: "",
      descriptionName: "",
      time2: "",
      priority: "",
      assigned: [],
      tags: [],
      file: null,
      errorDate: false,
      errorDesc: false,
      errorName: false,
      duplicateTags: [],
      duplicateTime: "",
      duplicatePriority: null,
      duplicateAssigned: [],
      dragMode: false,
      vesselSearch: false,
      regionList: [
        {name: "AG", id: "AG"},
        {name: "ARAG", id: "ARAG"},
        {name: "BALTIC", id: "BALTIC"},
        {name: "BLACK SEA", id: "BLACK SEA"},
        {name: "CARIBS", id: "CARIBS"},
        {name: "CASPIAN", id: "CASPIAN"},
        {name: "CENTRAL ATLANTIC", id: "CENTRAL ATLANTIC"},
        {name: "E AFRICA", id: "E AFRICA"},
        {name: "E AUSSIE", id: "E AUSSIE"},
        {name: "E MED", id: "E MED"},
        {name: "EC CAN", id: "EC CAN"},
        {name: "EC INDIA", id: "EC INDIA"},
        {name: "ECCA", id: "ECCA"},
        {name: "ECSA", id: "ECSA"},
        {name: "FEAST", id: "FEAST"},
        {name: "French Atl", id: "French Atl"},
        {name: "GREAT LAKES", id: "GREAT LAKES"},
        {name: "INDIAN OCEAN", id: "INDIAN OCEAN"},
        {name: "MID PACIFIC", id: "MID PACIFIC"},
        {name: "MIDNORTH ATLANTIC", id: "MIDNORTH ATLANTIC"},
        {name: "N CONT", id: "N CONT"},
        {name: "NCSA", id: "NCSA"},
        {name: "NEST PASSAGE", id: "NEST PASSAGE"},
        {name: "NOPAC", id: "NOPAC"},
        {name: "NW AFRICA", id: "NW AFRICA"},
        {name: "NWST PASSAGE", id: "NWST PASSAGE"},
        {name: "NZ", id: "NZ"},
        {name: "RED SEA", id: "RED SEA"},
        {name: "SE ASIA", id: "SE ASIA"},
        {name: "ST LAWRENCE", id: "ST LAWRENCE"},
        {name: "STH AFRICA", id: "STH AFRICA"},
        {name: "STH ANTARCTICA", id: "STH ANTARCTICA"},
        {name: "STH INDIAN OCEAN", id: "STH INDIAN OCEAN"},
        {name: "STH PACIFIC", id: "STH PACIFIC"},
        {name: "SW AFRICA", id: "SW AFRICA"},
        {name: "Spain Atl", id: "Spain Atl"},
        {name: "UK EIRE", id: "UK EIRE"},
        {name: "USEC", id: "USEC"},
        {name: "ASG", id: "ASG"},
        {name: "W AUSSIE", id: "W AUSSIE"},
        {name: "W MED", id: "W MED"},
        {name: "WC INDIA", id: "WC INDIA"},
        {name: "WCCA", id: "WCCA"},
        {name: "WCSA", id: "WCSA"},
      ],
      defaultRegionActive: [],
      activeRegion: [],
      activeClient: null,
      activeBroker: null,
      defaultBrokerActive: {},
      defaultClientActive: {},
      cargoSearch: false,
      cargoOurVesselSearch: false,
      activeShip: null,
      defaultActiveShip: null,
      cargoWithoutVessel: false,
      nameTaskType: 'manual',
      selectTypeTask: true,
      dataShips: [],
      activeCheckList: [],
      activeDaysForRepeat: [],
      formSelectDate: null,
      due_date_status: null,
      defaultActiveCheckList: null,
      assigneeTask: [],
    }
  },
  validations: {
    activeRegion: {
      required
    },
  },
  watch: function () {
  },
  methods: {
    ...mapActions(["axiosAddCheckboxesForTask", "axiosGetEmployeeById", "axiosAddNewChecklistAwait", "axiosGetTaskCheckList", "axiosShipDuplicate", "axiosCreateTaskOurVessel", "axiosGetAllContracts", "axiosCreateTaskCargo", "axiosCreateTaskVessell", "axiosGetClientsForDropdown","axiosCreateTask","axiosAddFileToTask"]),
    ...mapMutations(["setAlert"]),
    getSelectedVessel() {
      return this.activeShip ? [this.activeShip.id] : []
    },
    getActiveGroupRegion(region) {
      let groupActive = [];
      this.groupRegionList.map(a=> {
        let error = 0;
        a.listRegion.map(b=> {
          if(region.indexOf(b) === -1) {
            error++;
          }
        })
        if(error === 0) {
          groupActive.push({name: a.name, id: a.name, listRegion: a.listRegion})
        }
      })
      return groupActive
    },
    setDueDate(date) {
      this.formSelectDate = date
    },
    setActiveChecklist(data) {
      this.activeCheckList = data;
    },
    setSelectTypeTask(bool) {
      this.selectTypeTask = bool;
    },
    setActiveShip(data) {
      this.activeShip = data;
    },
    closeRegion(data) {
      let regionList = []
      data.map(a=> {
        a.listRegion.map(b=> {
          regionList.push(b)
        })
      })
      this.defaultRegionActive = regionList;
    },
    getShipContracts() {
      let ships = this.getContracts.filter(a => a.contract_type === 'SHIP')
      ships = ships.map(a=> {
        return {name: a.name, id: a.id, is_redelivery: a.is_redelivery};
      });
      return ships;
    },
    changeRegion(name) {
      // console.log(name)
      this.defaultRegionActive = [];
      name.map(a=> {
        a.listRegion.map(b=> {
          this.defaultRegionActive.push(b)
        })
      })
      // console.log("this.defaultRegionActive")
      // console.log(this.defaultRegionActive)
    },
    setActiveRegion(data) {
      // console.log(data)
      this.activeRegion = data;
      // this.defaultRegionActive = data
      // this.$v.activeRegion.$touch()
    },
    setActiveClient(data) {
      this.activeClient = data;
    },
    setActiveBroker(data) {
      this.activeBroker = data;
    },
    openMapModal() {
      if(this.activeRegion !== null && this.activeRegion !== undefined) {
        // console.log(this.activeRegion)
        this.$refs.modalMap.openModal(this.activeRegion);
      } else {
        this.$refs.modalMap.openModal([]);
      }
    },
    manuallyTaskEvent() {
      this.nameTaskType = 'manual';
      this.vesselSearch = false;
      this.cargoSearch = false;
      this.cargoOurVesselSearch = false;
      this.cargoWithoutVessel = false;
      this.$refs.dropMan.setActiveName("Manually task")
    },
    vesselSearchEvent() {
      this.nameTaskType = 'vesselTask';
      this.vesselSearch = true;
      this.cargoSearch = false;
      this.cargoOurVesselSearch = false;
      this.cargoWithoutVessel = false;
      this.$refs.dropMan.setActiveName("Vessel search")
      // this.$refs.dropMan.setActiveName("Vessel search with Cargo")
    },
    cargoSearchEvent() {
      this.vesselSearch = false;
      this.cargoSearch = true;
      this.cargoOurVesselSearch = false;
      this.cargoWithoutVessel = false;
      this.$refs.dropMan.setActiveName("Vessel search without Cargo")
    },
    cargoOurVesselSearchEvent() {
      this.nameTaskType = 'cargoTask';
      this.vesselSearch = false;
      this.cargoSearch = false;
      this.cargoOurVesselSearch = true;
      this.cargoWithoutVessel = false;
      this.$refs.dropMan.setActiveName("Cargo Search")
      // this.$refs.dropMan.setActiveName("Search Cargo for our Vessel")
    },
    cargoSearchWithoutVesselEvent() {
      this.vesselSearch = false;
      this.cargoSearch = false;
      this.cargoOurVesselSearch = false;
      this.cargoWithoutVessel = true;
      this.$refs.dropMan.setActiveName("Cargo Search without Vessel")
    },
    dragEnter() {
      this.dragMode = true;
    },
    deleteTagWhichUsed(tag) {
      this.$refs.modalDeleteTag.openModal(tag);
    },
    dragEnd() {
      this.dragMode = false;
    },
    async showModalDuplicate(data) {
      // console.log(data);
      this.show = true;
      this.selectTypeTask = false;
      this.taskName = data.name;
      this.descriptionName = data.description
      let dateCurrent = new Date();
      if(Array.isArray(data.days_for_repeat) === true) {
        this.activeDaysForRepeat = data.days_for_repeat.map(a=> {
          return new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), a)
        })
      }
      this.defaultActiveCheckList = data.check_list
      this.due_date_status = data.due_date_status
      if(data.execute_time !== null && (""+data.execute_time).length !== 0) {
        this.date = (new Date(data.execute_time));
      }
      this.duplicateTags = JSON.parse(JSON.stringify(data.tags));
      if(data.execute_time !== null) {
        let h = this.date.getHours();
        let m = this.date.getMinutes();
        if(m<10) {
          m="0"+m;
        }
        this.duplicateTime = h+":"+m;
      }
      this.activeShip = data.vessel;
      this.duplicatePriority = data.priority;

      if(Array.isArray(data.executors)) {
        for(let i=0; i<data.executors.length; i++) {
          if(Number.isInteger(data.executors[i]) === true) {
            let item = this.getEmployeesDataAll.find(a=> a.id === (data.executors[i]))
            if(!item) {
              item = await this.axiosGetEmployeeById(data.id)
            }
            data.executors[i] = item
          }
        }
      }

      this.assigneeTask = JSON.parse(JSON.stringify(data.executors));
    },
    async showModalDuplicateVessel(data) {
      // console.log(1);
      // console.log(data);
      if(Array.isArray(data.ships)) {
        this.dataShips = data.ships.map(a=> {
          return a.id
        })
      }
      this.vesselSearchEvent();
      this.show = true;
      this.selectTypeTask = false;
      this.taskName = data.task.name;
      this.descriptionName = data.task.description
          // .replace(/<\/?[^>]+(>|$)/g, "");
      if(data.task.execute_time !== null && (""+data.task.execute_time).length !== 0) {
        this.date = (new Date(data.task.execute_time));
      }
      this.defaultActiveCheckList = data.task.check_list
      // this.date = (new Date(data.task.execute_time));
      this.duplicateTags = JSON.parse(JSON.stringify(data.task.tags));
      if(data.task.execute_time !== null) {
        let h = this.date.getHours();
        let m = this.date.getMinutes();
        if(m<10) {
          m="0"+m;
        }
        this.duplicateTime = h+":"+m;
      }
      let dateCurrent = new Date();
      if(Array.isArray(data.task.days_for_repeat) === true) {
        this.activeDaysForRepeat = data.task.days_for_repeat.map(a=> {
          return new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), a)
        })
      }
      this.activeShip = data.task.vessel;
      this.due_date_status = data.task.due_date_status
      this.duplicatePriority = data.task.priority;
      if(Array.isArray(data.task.executors)) {
        for(let i=0; i<data.task.executors.length; i++) {
          if(Number.isInteger(data.task.executors[i]) === true) {
            let item = this.getEmployeesDataAll.find(a=> a.id === (data.task.executors[i]))
            if(!item) {
              item = await this.axiosGetEmployeeById(data.task.id)
            }
            data.executors[i] = item
          }
        }
      }
      this.assigneeTask = JSON.parse(JSON.stringify(data.task.executors));
      this.defaultRegionActive = data.region
      this.defaultActiveCheckList = data.task.check_list

      this.cargoName = data.cargo_text;
      this.activeBroker = data.brokers;
      this.activeClient = data.clients;
      // if(!this.clients.length) {
      //   this.axiosGetClientsForDropdown()
      //     this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //     this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // } else {
      //   this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //   this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // }
    },
    async showModalDuplicateCargo(data) {
      this.show = true;
      this.selectTypeTask = false;
      this.cargoSearchEvent();
      this.taskName = data.task.name;
      this.descriptionName = data.task.description;
      if(data.task.execute_time !== null && (""+data.task.execute_time).length !== 0) {
        this.date = (new Date(data.task.execute_time));
      }
      this.defaultActiveCheckList = data.task.check_list

      this.duplicateTags = JSON.parse(JSON.stringify(data.task.tags));
      if(data.task.execute_time !== null) {
        let h = this.date.getHours();
        let m = this.date.getMinutes();
        if(m<10) {
          m="0"+m;
        }
        this.duplicateTime = h+":"+m;
      }
      let dateCurrent = new Date();
      if(Array.isArray(data.task.days_for_repeat) === true) {
        this.activeDaysForRepeat = data.task.days_for_repeat.map(a=> {
          return new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), a)
        })
      }
      this.due_date_status = data.task.due_date_status
      this.duplicatePriority = data.task.priority;
      if(Array.isArray(data.task.executors)) {
        for(let i=0; i<data.task.executors.length; i++) {
          if(Number.isInteger(data.task.executors[i]) === true) {
            let item = this.getEmployeesDataAll.find(a=> a.id === (data.task.executors[i]))
            if(!item) {
              item = await this.axiosGetEmployeeById(data.task.id)
            }
            data.executors[i] = item
          }
        }
      }
      this.assigneeTask = JSON.parse(JSON.stringify(data.task.executors));
      this.defaultRegionActive = data.region
      this.activeBroker = data.brokers;
      this.activeShip = data.task.vessel;
      this.activeClient = data.clients;

      // if(!this.clients.length) {
      //   this.axiosGetClientsForDropdown()
      //   this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //   // this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // } else {
      //   this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //   // this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // }
    },
    async showModalDuplicateCargoWithVessel(data) {
      // console.log(1);
      // console.log(data);
      if(Array.isArray(data.ships)) {
        this.dataShips = data.ships.map(a=> {
          return a.id
        })
      }
      let dateCurrent = new Date();
      if(Array.isArray(data.task.days_for_repeat) === true) {
        this.activeDaysForRepeat = data.task.days_for_repeat.map(a=> {
          return new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), a)
        })
      }
      this.defaultActiveCheckList = data.task.check_list

      this.due_date_status = data.task.due_date_status
      this.show = true;
      this.selectTypeTask = false;
      this.cargoOurVesselSearchEvent();
      this.taskName = data.task.name;
      this.descriptionName = data.task.description;
      if(data.task.execute_time !== null && (""+data.task.execute_time).length !== 0) {
        this.date = (new Date(data.task.execute_time));
      }
      this.duplicateTags = JSON.parse(JSON.stringify(data.task.tags));
      if(data.task.execute_time !== null) {
        let h = this.date.getHours();
        let m = this.date.getMinutes();
        if(m<10) {
          m="0"+m;
        }
        this.duplicateTime = h+":"+m;
      }
      // if(data.ship !== null) {
      //   this.activeShip = data.ship
      //
      //   // this.defaultActiveShip = {name: data.ship.name + " CP Date - " + data.ship.contract.cp_date, id: data.ship.id};
      // }
      // this.activeShip = data.task.vessel;

      this.duplicatePriority = data.task.priority;
      if(Array.isArray(data.task.executors)) {
        for(let i=0; i<data.task.executors.length; i++) {
          if(Number.isInteger(data.task.executors[i]) === true) {
            let item = this.getEmployeesDataAll.find(a=> a.id === (data.task.executors[i]))
            if(!item) {
              item = await this.axiosGetEmployeeById(data.task.id)
            }
            data.executors[i] = item
          }
        }
      }
      this.assigneeTask = JSON.parse(JSON.stringify(data.task.executors));
      this.defaultRegionActive = data.region
      this.activeBroker = data.brokers;
      this.activeShip = data.task.vessel;
      this.activeClient = data.clients;
      // console.log(data)
      // if(!this.clients.length) {
      //   this.axiosGetClientsForDropdown()
      //   this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //   // this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // } else {
      //   this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //   // this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // }
    },
    async showModalDuplicateCargoWithOutVessel(data) {
      this.show = true;
      this.cargoSearchWithoutVesselEvent();
      this.selectTypeTask = false;
      this.taskName = data.task.name;
      this.descriptionName = data.task.description;
      if(data.task.execute_time !== null && (""+data.task.execute_time).length !== 0) {
        this.date = (new Date(data.task.execute_time));
      }
      let dateCurrent = new Date();
      if(Array.isArray(data.task.days_for_repeat) === true) {
        this.activeDaysForRepeat = data.task.days_for_repeat.map(a=> {
          return new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), a)
        })
      }

      this.due_date_status = data.task.due_date_status
      this.duplicateTags = JSON.parse(JSON.stringify(data.task.tags));
      // this.activeShip = data.task.vessel;
      if(data.task.execute_time !== null) {
        let h = this.date.getHours();
        let m = this.date.getMinutes();
        if(m<10) {
          m="0"+m;
        }
        this.duplicateTime = h+":"+m;
      }
      this.defaultActiveCheckList = data.task.check_list

      this.duplicatePriority = data.task.priority;
      if(Array.isArray(data.task.executors)) {
        for(let i=0; i<data.task.executors.length; i++) {
          if(Number.isInteger(data.task.executors[i]) === true) {
            let item = this.getEmployeesDataAll.find(a=> a.id === (data.task.executors[i]))
            if(!item) {
              item = await this.axiosGetEmployeeById(data.task.id)
            }
            data.executors[i] = item
          }
        }
      }
      this.assigneeTask = JSON.parse(JSON.stringify(data.task.executors));
      this.defaultRegionActive = data.region
      this.activeBroker = data.brokers;
      this.activeShip = data.task.vessel;
      this.activeClient = data.clients;
      // if(!this.clients.length) {
      //   this.axiosGetClientsForDropdown()
      //   this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //   // this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // } else {
      //   this.defaultBrokerActive = this.getClientsFormAddModal.filter(a=> a.id === data.brokers.id)[0];
      //   // this.defaultClientActive = this.getClientsFormAddModal.filter(a=> a.id === data.clients.id)[0];
      // }
    },


    testFile(e) {
      e.path[0].files
      if(this.getPermissionsForUserCanAddFile) {
        // console.log(this.$refs.dropzone);
        for(let i=0; i<e.path[0].files.length; i++) {
          this.$refs.dropzone.addFile(e.path[0].files[i])
        }
      }

    },
    mountedAssigned() {
      if(this.show === true && this.duplicateAssigned.length !==0) {
        this.assigneeTask = this.duplicateAssigned
      }
    },
    dragTetx() {
      // console.log(111);
    },
    mountedPriority() {
      if(this.show === true && this.duplicatePriority !== null) {
        this.$refs.priority.setPriorityForDuplicate(this.duplicatePriority);
      }
    },
    mountedTime() {
      // if(this.show === true && this.duplicateTime.length !== 0) {
      //   this.$refs.timeSelect.setTimeForDuplicate(this.duplicateTime)
      // }
    },
    mountedTagSelect() {
      if(this.show === true && this.duplicateTags.length !== 0) {
        this.$refs.tagsSel.selectForDuplicate(this.duplicateTags);
      }
    },
    // setAssigned(data) {
    //   // this.assigneeTask.map(a=>{return a.id}) = data;
    // },
    setTags(data) {
      this.tags = data;
    },
    time2Set(time) {
      this.time2 = time;
    },
    setPriority(id) {
      this.priority = id;
    },
    openDatePicker() {
      this.open = true;
    },
    closeDatePicker() {
      this.open = false;
    },
    setFile(file) {
      this.file = file;
    },
    changeDate() {
      if(this.date !== null || this.date.length !== 0) {
        if(this.date.getFullYear() < 2000) {
          this.date = (new Date(2000, this.date.getMonth(), this.date.getDate()));
        }
        if(this.date.getFullYear() > 2100) {
          this.date = (new Date(2100, this.date.getMonth(), this.date.getDate()));
        }
      }
    },
    hideModal() {
      this.clearData();
      this.show = false;
    },
    showModal() {
      this.show = true;
    },
    clearData() {
      this.actualListCheckList = [];
      this.actualSelectedIdsChecklist = []
      this.selectTypeTask = true;
      this.activeClient = null;
      this.cargoName = "";
      this.duplicateAssigned = [];
      this.duplicatePriority= null;
      this.duplicateTime = "";
      this.date = "";
      this.time2 = "";
      this.taskName = "";
      this.descriptionName = "";
      this.priority = "";
      if(this.getPermissionsForUserCanAddFile) {
        if( this.$refs.dropzone !== undefined &&  this.$refs.dropzone !== null) {
          this.$refs.dropzone.removeAllFiles(true);
        }
      }

      // this.$refs.timeSelect.clearData();
      this.$refs.priority.clearData();
      this.assigneeTask = []
      // this.$refs.assigneeTask.clearData();
      this.$refs.tagsSel.clearData();
      this.duplicateTags = [];
      this.defaultActiveShip = null;
      this.activeShip = null;
      this.defaultRegionActive = [];
      this.defaultActiveCheckList = [];
      this.activeBroker = null;
      this.duplicateTime = ''
      this.time2= "";
      // this.activeDaysForRepeat = [];
      // this.date = "";
      // this.due_date_status = null;
      this.$refs.selectDueaDate.clearData()
      this.formSelectDate = null
    },
    async createTask() {
      // this.$v.activeRegion.$touch()
      this.time2 = "";
      // this.taskName = "";
      // this.descriptionName = "";
      this.priority = "";
      this.tags.splice(0,this.tags.length)
      // this.$refs.timeSelect.getTimeInInput();
      this.$refs.priority.getPriorityinInput();
      // this.$refs.assigneeTask.getDataForAxios();
      this.$refs.tagsSel.getTagsForAxios();

      // console.log(1)
      if(this.taskName.length === 0) {
        this.errorName = true;
      } else {
        this.errorName = false;
      }
      // console.log(11)
      // if(this.descriptionName.length === 0) {
      //   this.errorDesc = true;
      // } else {
      //   this.errorDesc = false;
      // }
      // if(this.date.length === 0) {
      //   this.errorDate = true;
      // } else {
      //   this.errorDate = false;
      // }

      // let mm = this.date.getMonth();
      // if(mm<10) {
      //   mm = "0"+mm;
      // }
      // let dd = this.date.getDate();
      // if(dd<10) {
      //   dd = "0" + dd;
      // }
      // if(this.time2 === "Not chosen") {
      //   this.time2 = "00:00"
      // }
      // let time = "" + this.date.getFullYear() + "-" + mm + "-" + dd + "T"+ this.time2;
      let time = "";
      if(this.date !==null && (''+this.date).length !== 0) {
        time = new Date(this.date.getFullYear(), this.date.getMonth(),this.date.getDate())
        if(this.time2 !== "Not chosen") {
          let h = 0;
          let m = 0;
          // let h = this.time2[0] +this.time2[1];
          // let m = this.time2[3] +this.time2[4];
          if(this.time2.length===4) {
            h = this.time2[0];
            m = this.time2[2] +this.time2[3];
          }
          if(this.time2.length===5) {
            h = this.time2[0] +this.time2[1];
            m = this.time2[3] +this.time2[4];
          }
          // console.log(this.time2)
          // console.log(h)
          // console.log(m)
          time = new Date(this.date.getFullYear(), this.date.getMonth(),this.date.getDate(), h, m)
        }
      }
      if(time.length === 0) {
        time = null;
      }
      let check_list = [];
      // if(this.activeCheckList.length !== 0) {
      //   check_list = this.activeCheckList.map(a=> {
      //     return a.id;
      //   })
      // }
      // if(Array.isArray(this.activeCheckList) === true) {
      //   for(let i = 0; i<this.activeCheckList.length; i++) {
      //     let item = this.activeCheckList[i]
      //     let checkListAxios = item.check_list.map(a=> {
      //       return {name: a.name, is_done: false}
      //     })
      //     let res = await this.axiosAddNewChecklistAwait({name: item.name, check_list: checkListAxios, is_template: false, parent_id: item.id})
      //     check_list.push(res.id)
      //   }
      //
      // }
      let days_for_repeat = [];
      if(this.formSelectDate !== null) {
        days_for_repeat = this.formSelectDate.days_for_repeat;
      }
      let due_date_status = "due_date"
      if(this.formSelectDate !== null) {
        due_date_status = this.formSelectDate.due_date_status;
      }

      let ship = null;
      if(this.activeShip !== null && this.activeShip !== undefined) {
        ship = this.activeShip.id
      }
      let execute_time = "";
      // console.log(2)
      if(this.formSelectDate !== null) {
        execute_time = this.formSelectDate.execute_time;
        if(this.time2 !== "Not chosen" && this.formSelectDate.execute_time !== null && (""+this.formSelectDate.execute_time).length !== 0) {
          // console.log(execute_time)
          execute_time = moment(execute_time).format("YYYY-MM-DD") + ((this.time2 !== null && (""+this.time2).length !== 0 ? " " + this.time2 : " 00:00"))
          // console.log(execute_time)
        }
      }
      if(!this.vesselSearch && !this.cargoSearch && !this.cargoOurVesselSearch && !this.cargoWithoutVessel) {
        let check_listIds = this.actualSelectedIdsChecklist && this.actualSelectedIdsChecklist.length !== 0 ? this.actualSelectedIdsChecklist : [];
        let checkListItems = this.actualListCheckList;
        this.axiosCreateTask({ship: ship, name: this.taskName, description: this.descriptionName, execute_time: execute_time, priority: Number(this.priority), executors: this.assigneeTask.map(a=>{return a.id}), tags: this.tags, status: "Open", type: "MANUAL", check_list: check_listIds, days_for_repeat: days_for_repeat, due_date_status: due_date_status}).then(async ()=> {
          // this.getResponseCreateTask
          let file = [];
          if(this.getPermissionsForUserCanAddFile) {
            file = this.$refs.dropzone.getAcceptedFiles();
          }
            this.axiosAddFileToTask({id: this.getResponseCreateTask.id, file: file, fileInPayment: []});
          if(checkListItems && Array.isArray(checkListItems) === true && checkListItems.length) {
            let items = []
            checkListItems.forEach(checklist=> {
              checklist.items.forEach(item=> {
                let form = {
                  task: this.getResponseCreateTask.id,
                  checklist_item: item.id,
                  priority: item.priority ? item.priority.id : null,
                  due_date: item.due_date ? item.due_date : null,
                  days_for_repeat: Array.isArray(item.days_for_repeat) === true ? item.days_for_repeat : [],
                  due_date_status: item.due_date_status ? item.due_date_status : null,
                  is_hidden: !item.is_hidden && item.is_hidden !== false ? false : item.is_hidden,
                  is_completed: false,
                }
                items.push(form)
              })
            })
            await this.axiosAddCheckboxesForTask(items)
          }
          this.clearData();
          this.hideModal();
          this.$emit("renderTaskList")
        });
      } else if(this.cargoOurVesselSearch) {
        // console.log(5)
        let region = [];
        if(this.activeRegion !== null && this.activeRegion !== undefined) {
           this.activeRegion.map(a=> {return a.listRegion.map(b=> {
             region.push(b)
          })});
        }
        let broker = "";
        if(this.activeBroker !== null && this.activeBroker !== undefined) {
          broker = this.activeBroker.id;
        }
        // let ship = null;
        // if(this.activeShip !== null && this.activeShip !== undefined) {
        //   ship = this.activeShip.id
        // }
        let task = {vessel: ship, creator_id: this.getLoginData.data.user.id,name: this.taskName, description: this.descriptionName, execute_time: execute_time, priority: Number(this.priority), executors: this.assigneeTask.map(a=>{return a.id}), tags: this.tags, status: "Open", type: "CARGO_SEARCH_WITH_SHIP", check_list: check_list, days_for_repeat: days_for_repeat, due_date_status: due_date_status}
        // console.log(task)
        // console.log(broker)
        this.axiosCreateTaskOurVessel({task: task, region: region, brokers: broker}).then(res=> {
          // this.getResponseCreateTask
          let file = [];
          // console.log(file);
          if(this.getPermissionsForUserCanAddFile) {
            file = this.$refs.dropzone.getAcceptedFiles();
          }
          // console.log(file.length)
          this.axiosShipDuplicate({task_id: res.data.id, ship_ids: this.dataShips})
          // for(let i=0; i<file.length; i++) {
            this.axiosAddFileToTask({id: this.getResponseCreateTask.task.id, file: file, fileInPayment: []});
          // }
          // this.setAlert({show: true, text: "Task add!"})
          this.clearData();
          this.hideModal();
          this.$emit("renderTaskList")
        });
      } else if(this.cargoWithoutVessel) {
        console.log(6)
        let region = [];
        if(this.activeRegion !== null && this.activeRegion !== undefined) {
          this.activeRegion.map(a=> {return a.listRegion.map(b=> {
            region.push(b)
          })});
        }
        let broker = "";
        if(this.activeBroker !== null && this.activeBroker !== undefined) {
          broker = this.activeBroker.id;
        }
        let task = {creator_id: this.getLoginData.data.user.id,name: this.taskName, description: this.descriptionName, execute_time: execute_time, priority: Number(this.priority), executors: this.assigneeTask.map(a=>{return a.id}), tags: this.tags, status: "Open", type: "CARGO_SEARCH_WITHOUT_SHIP", check_list: check_list, days_for_repeat: days_for_repeat, due_date_status: due_date_status}
        this.axiosCreateTaskOurVessel({task: task, region: region, brokers: broker}).then(()=> {
          // this.getResponseCreateTask
          let file = [];
          // console.log(file);
          if(this.getPermissionsForUserCanAddFile) {
            file = this.$refs.dropzone.getAcceptedFiles()
          }
          // console.log(file.length)
          // for(let i=0; i<file.length; i++) {
            this.axiosAddFileToTask({id: this.getResponseCreateTask.task.id, file: file, fileInPayment: []});
          // }
          // this.setAlert({show: true, text: "Task add!"})
          this.clearData();
          this.hideModal();
          this.$emit("renderTaskList")
        });
      } else if(this.cargoSearch) {
        // console.log(7)
        let region = [];
        if(this.activeRegion !== null && this.activeRegion !== undefined) {
          this.activeRegion.map(a=> {return a.listRegion.map(b=> {
            region.push(b)
          })});
        }
        let broker = "";
        if(this.activeBroker !== null && this.activeBroker !== undefined) {
          broker = this.activeBroker.id;
        }
        let task = {creator_id: this.getLoginData.data.user.id,name: this.taskName, description: this.descriptionName, execute_time: execute_time, priority: Number(this.priority), executors: this.assigneeTask.map(a=>{return a.id}), tags: this.tags, status: "Open", type: "SHIP_SEARCH_WITHOUT_CARGO", check_list: check_list, days_for_repeat: days_for_repeat, due_date_status: due_date_status}
        this.axiosCreateTaskCargo({task: task, region: region, brokers: broker}).then(()=> {
          // this.getResponseCreateTask
          let file = [];
          // console.log(file);
          if(this.getPermissionsForUserCanAddFile) {
            file = this.$refs.dropzone.getAcceptedFiles()
          }
          // console.log(file.length)
          // for(let i=0; i<file.length; i++) {
            this.axiosAddFileToTask({id: this.getResponseCreateTask.task.id, file: file, fileInPayment: []});
          // }
          // this.setAlert({show: true, text: "Task add!"})
          this.clearData();
          this.hideModal();
          this.$emit("renderTaskList")
        });
      } else {
        // console.log(8)
        let region = [];
        if(this.activeRegion !== null && this.activeRegion !== undefined) {
          this.activeRegion.map(a=> {return a.listRegion.map(b=> {
            region.push(b)
          })});
        }
        let cargo_text = this.cargoName;
        let client = "";
        if(this.activeClient !== null && this.activeClient !== undefined) {
          client = this.activeClient.id;
        }
        let broker = "";
        if(this.activeBroker !== null && this.activeBroker !== undefined) {
          broker = this.activeBroker.id;
        }
        let task = {vessel: ship, creator_id: this.getLoginData.data.user.id,name: this.taskName, description: this.descriptionName, execute_time: execute_time, priority: Number(this.priority), executors: this.assigneeTask.map(a=>{return a.id}), tags: this.tags, status: "Open", type: "SHIP_SEARCH_WITH_CARGO", check_list: check_list, days_for_repeat: days_for_repeat, due_date_status: due_date_status}

        this.axiosCreateTaskVessell({task: task, region: region, cargo_text: cargo_text, clients: client, brokers: broker}).then(res=> {
          // this.getResponseCreateTask
          // console.log(file);
          let file = [];
          if(this.getPermissionsForUserCanAddFile) {
            file = this.$refs.dropzone.getAcceptedFiles()
          }
          // console.log(file.length)
          this.axiosShipDuplicate({task_id: res.data.id, ship_ids: this.dataShips})

          // for(let i=0; i<file.length; i++) {
            this.axiosAddFileToTask({id: this.getResponseCreateTask.task.id, file: file, fileInPayment: []});
          // }
          // this.setAlert({show: true, text: "Task add!"})
          this.clearData();
          this.hideModal();
          this.$emit("renderTaskList")
        });
      }
      // console.log({name: this.taskName, description: this.descriptionName, execute_time: time, priority: Number(this.priority), executors: this.assigneeTask.map(a=>{return a.id}), tags: this.tags, status: "Open", type: "MANUAL"});
      // let file = this.$refs.dropzone.getAcceptedFiles();
      // // console.log(file);
      // // console.log(this.$refs.dropzone.getAcceptedFiles())
    },
    openChekcListModal() {
      this.$emit("openCheckList")
    }
  },
  mounted() {
    // if(!this.getContracts.length) {
    //   this.axiosGetAllContracts({limit: 100, propsData: {contract_type: ["SHIP"], }});
    // }
    // if(!this.clients.length) {
    //   this.axiosGetClientsForDropdown();
    // }
    if(!this.getCheckListForSelect.length) {
      this.axiosGetTaskCheckList();
    }
  }
}
</script>

<style scoped lang="scss">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
  @import "manually-task-add";

.wrap-content {
  width: 100%;
}
.modal-with-checklist-section {
  .modal {
    width: 1200px;
  }
  .wrap-content {
    display: flex;
    &>*:nth-child(1) {
      width: calc(50% + 24px);
      box-sizing: border-box;
    }
    &>*:nth-child(2) {
      width: calc(50% - 24px);
      box-sizing: border-box;
      padding-right: 24px;
      padding-bottom: 20px;
      padding-top: 16px;
    }
  }
}
</style>